import { 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Grid
} from "@mui/material";
import { TagRule, TagRuleStatus } from "models/events/TagRule";
import { useState, useEffect } from "react";

interface RuleInfoProps {
  tagRule: TagRule;
  onTagRuleChange: (tagRule: TagRule) => void;
}

export const RuleInfo = ({ tagRule, onTagRuleChange }: RuleInfoProps) => {
  const [localTagRule, setLocalTagRule] = useState<TagRule>(tagRule);

  useEffect(() => {
    setLocalTagRule(tagRule);
  }, [tagRule]);

  const handleFieldChange = (field: keyof TagRule, value: any) => {
    const updatedTagRule = Object.assign(new TagRule(), { ...localTagRule, [field]: value });
    setLocalTagRule(updatedTagRule);
    onTagRuleChange(updatedTagRule);
  };

  const handleConditionChange = (value: string) => {
    try {
      const parsedCondition = value ? JSON.parse(value) : null;
      handleFieldChange('condition', parsedCondition);
    } catch (error) {
      // If JSON is invalid, store as string for now
      handleFieldChange('condition', value);
    }
  };

  const getConditionDisplayValue = () => {
    if (!localTagRule.condition) return '';
    if (typeof localTagRule.condition === 'string') return localTagRule.condition;
    return JSON.stringify(localTagRule.condition, null, 2);
  };

  return (
    <Grid container spacing={3}>
      <Grid size={6}>
        <TextField
          fullWidth
          label="Name"
          value={localTagRule.name || ''}
          onChange={(e) => handleFieldChange('name', e.target.value)}
          variant="outlined"
          required
        />
      </Grid>
      
      <Grid size={6}>
        <TextField
          fullWidth
          label="Tagged Expiration Days"
          type="number"
          value={localTagRule.taggedExpirationDays || ''}
          onChange={(e) => handleFieldChange('taggedExpirationDays', e.target.value ? parseInt(e.target.value) : null)}
          variant="outlined"
          inputProps={{ min: 0 }}
          helperText="Number of days before tagged items expire"
        />
      </Grid>
      
      <Grid size={12}>
        <TextField
          fullWidth
          label="Description"
          value={localTagRule.description || ''}
          onChange={(e) => handleFieldChange('description', e.target.value)}
          variant="outlined"
          multiline
          rows={3}
        />
      </Grid>
      
    </Grid>
  );
}; 